import { useEffect } from 'react';

const useDisableBodyScroll = (isDisabled: boolean, selector?: string) => {
  const targetElement: any = selector ? document.querySelector(selector) || document.body : document.body;

  useEffect(() => {
    if (isDisabled) {
      targetElement.style.overflow = 'hidden';
    } else {
      targetElement.style.overflow = 'auto';
    }

    return () => {
      targetElement.style.overflow = 'auto';
    };
  }, [isDisabled, targetElement]);
};

export default useDisableBodyScroll;